import { useCallback } from "react";
import { useAuth } from "@/contexts/AuthContext";

export const WA_VARS = ["cliente", "placa", "modelo", "oficina", "link", "valor", "data", "pix", "cliente_nome", "oficina_nome", "veiculo"];

export const WA_TEMPLATES = [
  { key: "budget_ready", label: "Orçamento pronto", text: "Olá, {cliente}! O orçamento do seu {modelo} {placa} está pronto: {valor}.\n\nVeja e aprove por aqui: {link}" },
  { key: "budget_followup", label: "Cobrar orçamento parado", text: "Olá, {cliente}! Conseguiu ver o orçamento do {placa} ({valor})? Qualquer dúvida é só me chamar. — {oficina}\n{link}" },
  { key: "status_update", label: "Atualização de status", text: "Olá, {cliente}! Atualização do seu veículo {placa}: {status}.\n\nAcompanhe pelo app: {link}", extra: ["status"] },
  { key: "car_ready", label: "Carro pronto", text: "Olá, {cliente}! Seu {modelo} {placa} está pronto para retirada aqui na {oficina}. Total: {valor}.\n\nDetalhes: {link}" },
  { key: "revision", label: "Lembrete de revisão", text: "Olá, {cliente}! Lembrete: a próxima revisão do {placa} está prevista para {data}. Podemos agendar? — {oficina}" },
  { key: "birthday", label: "Aniversário", text: "Feliz aniversário, {nome}! Muito obrigado por confiar na {oficina}. 🎉", extra: ["nome"] },
  { key: "lost", label: "Cliente sumido", text: "Olá, {cliente}! Faz tempo que você não aparece aqui na {oficina}. Precisa de alguma revisão? Posso te encaixar para uma vistoria rápida." },
  { key: "review", label: "Pós-venda / avaliação", text: "Olá, {cliente}! Foi um prazer atender o {placa} aqui na {oficina}. Se puder deixar uma avaliação no Google, ajuda muito a gente: {link}\nObrigado!" },
  { key: "booking_confirm", label: "Confirmação de agendamento", text: "Olá, {cliente}! Seu agendamento na {oficina} está confirmado para {data}. Placa {placa}. Até lá!" },
  { key: "booking_reminder", label: "Lembrete de agendamento (véspera)", text: "Olá, {cliente}! Passando para lembrar: seu agendamento na {oficina} é {data}. Placa {placa}. Se não puder vir, me avise por aqui. Até amanhã!" },
  { key: "track_link", label: "Link de acompanhamento (QR)", text: "Olá, {cliente}! Acompanhe a OS do seu veículo {placa} por aqui: {link}\nPara abrir, digite os 4 últimos dígitos do seu telefone." },
  { key: "oil", label: "Troca de óleo", text: "Olá, {cliente}! Está chegando a hora da troca de óleo do seu {modelo} {placa}: a próxima é aos {km} ou em {data}. Quer agendar? — {oficina}", extra: ["km"] },
  { key: "part_due", label: "Vencimento de peça", text: "Olá, {cliente}! Está chegando a hora de revisar/trocar a peça {peca} do seu {veiculo} placa {placa} (vence {data}). Quer agendar? — {oficina}", extra: ["peca"] },
  { key: "survey", label: "Pesquisa de satisfação", text: "Olá, {cliente}! Obrigado por confiar na {oficina}. Como foi o serviço no seu {placa}? Avalie em 10 segundos: {link}" },
];

const DEFAULTS = Object.fromEntries(WA_TEMPLATES.map((t) => [t.key, t.text]));

export const fillTpl = (tpl, vars) => tpl.replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null && vars[k] !== "" ? String(vars[k]) : ""))
  .replace(/[ \t]{2,}/g, " ").replace(/ ([,.!?])/g, "$1").trim();

// Marca + modelo base (primeira palavra do modelo FIPE), ex.: "Volkswagen Amarok".
export const vehicleShort = (v) => {
  if (!v) return "";
  const make = ((v.make || "").includes(" - ") ? v.make.split(" - ").pop() : v.make || "").trim().split(/\s+/)[0] || "";
  const base = (v.model || "").trim().split(/[\s/]+/)[0] || "";
  return [make.charAt(0).toUpperCase() + make.slice(1).toLowerCase(), base].filter(Boolean).join(" ");
};

export const waUrl = (phone, text) => {
  const d = String(phone || "").replace(/\D/g, "");
  if (!d) return "";
  return `https://wa.me/${d.length >= 12 ? d : `55${d}`}?text=${encodeURIComponent(text)}`;
};

export const budgetPdfMsg = (v, pdfUrl) =>
  `Olá ${v.cliente || ""}, segue o PDF do orçamento do veículo ${v.placa || ""} (${v.modelo || ""}) — valor ${v.valor || ""}: ${pdfUrl || ""}`;

export const intakePdfMsg = (v, pdfUrl) =>
  `Olá ${v.cliente || ""}, segue o checklist de entrada do seu veículo ${v.placa || ""} (${v.modelo || ""}) com as fotos: ${pdfUrl || ""}`;

export function useWaMsg() {
  const { user } = useAuth();
  const custom = user?.shop?.wa_templates || {};
  const shopName = user?.shop?.name || "nossa oficina";
  const pix = user?.shop?.pix?.key ? `${user.shop.pix.key} (${user.shop.pix.name || shopName})` : "";
  const customKey = JSON.stringify(custom);
  return useCallback((key, vars = {}) => {
    const v = { oficina: shopName, pix, ...vars };
    v.cliente_nome = v.cliente_nome ?? v.cliente ?? v.nome; v.oficina_nome = v.oficina_nome ?? v.oficina; v.veiculo = v.veiculo ?? v.modelo;
    if (v.nome == null) { v.nome = v.cliente; }
    return fillTpl(custom[key] || DEFAULTS[key] || "", v);
  },
    [customKey, shopName, pix]); // eslint-disable-line react-hooks/exhaustive-deps
}
